<template>
  <v-row class="flex-column text-center justify-center">
    <v-icon class="big-icon my-6" color="#34A853">check_circle</v-icon>
    <div style="color: var(--primary-color-blue);" class="display font-weight-bold mb-12">
      {{ $t("recharge.recharge_done") }}
    </div>
    <v-btn
      color="#000230"
      class="textOverSecondary--text semi-rounded my-6 mx-auto px-12 py-8"
      style="width: 330px;"
      @click="redirectToHome"
    >
      <span style="color: white;">
        {{ $t("actions.ok") }}
      </span>
    </v-btn>
  </v-row>
</template>
<script>
export default {
  props: ["routeNames"],
  methods: {
    redirectToHome() {
      const url = this.$router.resolve({ name: this.routeNames.WALLET });
      window.parent.location.href = url.href;
    },
  },
};
</script>
